import { render, staticRenderFns } from "./MoneyTextField.vue?vue&type=template&id=6b6d68f5&scoped=true"
import script from "./MoneyTextField.vue?vue&type=script&lang=ts"
export * from "./MoneyTextField.vue?vue&type=script&lang=ts"
import style0 from "./MoneyTextField.vue?vue&type=style&index=0&id=6b6d68f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6d68f5",
  null
  
)

export default component.exports